import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Money } from '../Money';

import TimedDelivery from '../../types/cart/TimedDelivery';

type TimedDeliveryDescriptionProps = TimedDelivery & {
  price?: number;
  renderDefaultTimeSlotIfEmpty?: boolean;
};

const TimedDeliveryDescription = ({
  before,
  after,
  price,
  renderDefaultTimeSlotIfEmpty = false,
}: TimedDeliveryDescriptionProps) => {
  const renderedPrice = typeof price !== 'undefined' ? (
    <>
      {' '}
      <span data-cy="timedDeliveryDescription.price">
        ({price === 0 ? <FormattedMessage id="generic.free" defaultMessage="Free" /> : <Money value={price * 100} />})
      </span>
    </>
  ) : null;

  if (before && after) {
    return (
      <>
        <FormattedMessage
          id="timedDelivery.between"
          defaultMessage="Between {after} and {before}"
          values={{
            before: <span data-cy="timedDeliveryDescription.before">{before}</span>,
            after: <span data-cy="timedDeliveryDescription.after">{after}</span>,
          }}
          data-cy="timedDeliveryDescription"
        />{renderedPrice}
      </>
    );
  }

  if (before) {
    return (
      <>
        <FormattedMessage
          id="timedDelivery.before"
          defaultMessage="Before {before}"
          values={{
            before: <span data-cy="timedDeliveryDescription.before">{before}</span>,
          }}
          data-cy="timedDeliveryDescription"
        />{renderedPrice}
      </>
    );
  }

  if (after) {
    return (
      <>
        <FormattedMessage
          id="timedDelivery.after"
          defaultMessage="After {after}"
          values={{
            after: <span data-cy="timedDeliveryDescription.after">{after}</span>,
          }}
          data-cy="timedDeliveryDescription"
        />{renderedPrice}
      </>
    );
  }

  if (renderDefaultTimeSlotIfEmpty) {
    return (
      <>
        <FormattedMessage
          id="timedDelivery.defaultTimeSlot"
          defaultMessage="Between 08:00 and 17:00"
          data-cy="timedDeliveryDescription"
        />{renderedPrice}
      </>
    );
  }

  return null;
};

export default TimedDeliveryDescription;
